import JSONApiService from "@/services/JSONApiService";
import { USER_MODEL } from "@/models/user-model";
import { DATA } from "@/models/relationships";
import { EXPERIENCE_MODEL } from "@/models/experience-model";
import { REASONS_FOR_LEAVING_MODEL } from "@/models/reasons-for-leaving-model";
import { EXPERIENCE_FUNCTION_MODEL } from "@/models/experience-function-model";
import { disablePluralizeForCall } from "@/services/utils";

const qualificationApi = commit => ({
  getUserExperience: async userId =>
    JSONApiService(commit)
      .one(USER_MODEL, userId)
      .all(EXPERIENCE_MODEL)
      .get(),
  getUserBookingExperience: async ({ userId, bookingId }) =>
    JSONApiService(commit)
      .one(USER_MODEL, userId)
      .one(EXPERIENCE_MODEL, bookingId)
      .get(),
  addUserExperience: async data =>
    JSONApiService(commit)
      .all(EXPERIENCE_MODEL)
      .post(data),
  removeUserExperience: async id =>
    JSONApiService(commit)
      .one(EXPERIENCE_MODEL, id)
      .destroy(),
  editUserExperience: async experience =>
    JSONApiService(commit)
      .one(EXPERIENCE_MODEL, experience.id)
      .patch(experience),
  getReasonsForLeaving: async () => {
    const api = JSONApiService(commit);
    api.all(DATA);
    disablePluralizeForCall(api, () => api.all(REASONS_FOR_LEAVING_MODEL));
    return api.get();
  },
  getExperienceFunctions: async params =>
    JSONApiService(commit)
      .all(DATA)
      .all(EXPERIENCE_FUNCTION_MODEL)
      .get(params)
});

export default qualificationApi;
